// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"4":"f3f3bc85","120":"89f169cb","856":"58e6a5a9"}[chunkId] + ".js";
};